import type { RetailEnvironmentConfig } from '@retail/core-config';
import { setCookie } from '@luna/cookies';

interface LocationCompatible {
    search: string;
    hash: string;
}
export class TPPFallbackHandler {
    config: RetailEnvironmentConfig;

    location: LocationCompatible;

    constructor(config: RetailEnvironmentConfig, location: LocationCompatible) {
        this.config = config;
        this.location = location;
    }

    handleTPPLoginRedirect(): void {
        if (this.isTPPFallback()) {
            this.setCSRFStateCookie();
            document.location.href = this.getTPPLoginURL();
            throw new Error('Stop code execution after redirect');
        }
    }

    isTPPFallback(): boolean {
        if (this.config.TPPfallback !== true) {
            return false;
        }

        return !!this.getTPPState() && !!this.getTPPRequest();
    }

    getTPPLoginURL(): string {
        const loginURL = new URL(this.config.loginUrl);

        loginURL.searchParams.set('state', this.getTPPState());
        loginURL.searchParams.set('request', this.getTPPRequest());
        loginURL.searchParams.set('client_id', this.config.clientId);

        return loginURL.href;
    }

    getTPPState(): string {
        return new URLSearchParams(this.location.search).get('state') || '';
    }

    getTPPRequest(): string {
        return new URLSearchParams(this.location.search).get('request') || '';
    }

    setCSRFStateCookie() {
        setCookie('gt_csrf', this.getCSRFfromTPPState());
    }

    getCSRFfromTPPState() {
        return this.getTPPState().split('||')[1] || '';
    }
}
